import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import TokenIcon from "@mui/icons-material/Token";
import Checkbox from "@mui/material/Checkbox";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SbtTokenListTable = ({
  sbtTokens,
  onSelect,
  selectedTokens,
  showConsent,
  title="SBT Tokens"
}) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell colSpan={showConsent ? 3 : 2}>{title}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sbtTokens.map((token) => (
            <TableRow>
              <TableCell>
                {selectedTokens ? (
                  <Checkbox
                    checked={selectedTokens.includes(token.id)}
                    onChange={() => onSelect(token.id)}
                  />
                ) : (
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => onSelect(token.id)}
                  >
                    <TokenIcon />
                  </IconButton>
                )}
              </TableCell>
              <TableCell component="th" scope="row">
                {token.id}
              </TableCell>
              {showConsent && (
                <TableCell component="th" scope="row">
                  {token.owner_consent ? <CheckCircleIcon /> : <CancelIcon />}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SbtTokenListTable;
